/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/517/interface/api/cat_2776
 */

import { message } from 'ant-design-vue'
import {
  cms_template_upload_post,
  cms_template_add_post,
  cms_template_list_post,
  cms_template_delete_post,
  cms_material_upload_post,
  cms_material_add_post,
  cms_material_list_post,
  cms_template_update_post,
  cms_material_delete_post,
  cms_collect_listing_post,
  cms_collect_detail_product_more_collectId_post,
  cms_product_listing_post,
  cms_skc_listing_post,
  cms_template_get_id_post,
  cms_template_getByEnName_post
} from 'server/modules/2776'

// 模板上传
export const cms_template_upload_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_upload_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存模板
export const cms_template_add_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 模板列表查询
export const cms_template_list_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 模板删除
export const cms_template_delete_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 素材上传
export const cms_material_upload_post_ = async function(params) {
  const { success, data, retInfo } = await cms_material_upload_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存素材
export const cms_material_add_post_ = async function(params) {
  const { success, data, retInfo } = await cms_material_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 素材列表查询
export const cms_material_list_post_ = async function(params) {
  const { success, data, retInfo } = await cms_material_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更新模板
export const cms_template_update_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_update_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 素材删除
export const cms_material_delete_post_ = async function(params) {
  const { success, data, retInfo } = await cms_material_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// Collection类目列表
export const cms_collect_listing_post_ = async function(params) {
  const { success, data, retInfo } = await cms_collect_listing_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// Collection商品详情
export const cms_collect_detail_product_more_collectId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await cms_collect_detail_product_more_collectId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// Product产品列表查询
export const cms_product_listing_post_ = async function(params) {
  const { success, data, retInfo } = await cms_product_listing_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// skc商品查询
export const cms_skc_listing_post_ = async function(params) {
  const { success, data, retInfo } = await cms_skc_listing_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据模板id查询模板信息
export const cms_template_get_id_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_get_id_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据英文名称查询模板
export const cms_template_getByEnName_post_ = async function(params) {
  const { success, data, retInfo } = await cms_template_getByEnName_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
